module.exports = __webpack_public_path__ + "img/AR.b48c0054.webp";